import React from 'react'

import { useParams } from 'react-router-dom'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

import { NcForm } from './components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'

const NcEdit = () => {
  const { monitoringManagementNcId } = useParams()

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementNc.show,
    { monitoringManagementNcId },
    [monitoringManagementNcId],
  )

  const monitoringManagementNc = response?.data?.monitoringManagementNc

  return (
    <Page title="Edição de NC - Monitoramento">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Não Conformidade (NC)" />
        {!isLoading && (
          <NcForm
            monitoringManagementNc={monitoringManagementNc}
            refresh={refresh}
          />
        )}
      </Container>
    </Page>
  )
}

export default NcEdit
